import React from "react";
import {
  TbEye,
  TbEyeOff,
  TbInfoCircle,
  TbMail,
  TbPhoneCall,
  TbUserCircle
} from "react-icons/tb";
import { Link } from "react-router-dom";
import LoginImg from "../../assets/image/login-bg.jpeg";
import Logo from "../../assets/svgs/logo";
import {
  Box,
  Button,
  Col,
  Gap,
  InputField,
  Row,
  SelectField,
  Tooltip,
  Typography
} from "../../ppui";
import { Brand, ContentBox, FooterBox, FromBox, ImageBox, PasswordToggleIcon, ScreenLayout } from "./style";
import useRegistrationService from "./use-registration-service";

const Registration = ({ openSnackbar }) => {

  const { handleSubmit, handleChange, errors, signUpData, handleBlurFn, showPassword, togglePasswordVisibility } = useRegistrationService({ openSnackbar });



  return (
    <>
      <ScreenLayout>
        <ImageBox>
          <img src={LoginImg} alt="Login background" />
        </ImageBox>
        <ContentBox>
          <Brand>
            <Logo />
          </Brand>
          <FromBox>
            <Typography variant="h3" mb={"10"}>
              Registration
            </Typography>
            {/* <Typography variant="body2" color="dark" colorVariant="light">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis massa
              lacus, finibus vel tincidunt non, malesuada non turpis.
            </Typography> */}
            <Gap height={30} />

            <Row>
              <Col sm={12} lg={10} xl={8}>
                <Row>
                  <Col xs={12} md={12}>
                    <Box pb={22}>
                      <InputField
                        name="first_name"
                        type="text"
                        label="Your Name"
                        variant="standard"
                        required={true}
                        placeholder="First Name"
                        fullWidth
                        labelBold
                        prefix={<TbUserCircle />}
                        value={signUpData?.first_name}
                        valueSinc={!!signUpData?.first_name}
                        onChange={(e) => handleChange(e.target.value, "first_name")}
                        helperText={errors.first_name}
                        error={errors.first_name}
                        onBlur={(e) => handleBlurFn(e, "first_name")}
                      />
                    </Box>
                  </Col>
                  <Col xs={12} md={12}>
                    <Box pb={22}>
                      <InputField
                        name="last_name"
                        type="text"
                        variant="standard"
                        required={true}
                        placeholder="Last Name"
                        fullWidth
                        labelBold
                        prefix={<TbUserCircle />}
                        value={signUpData?.last_name}
                        onChange={(e) => handleChange(e.target.value, "last_name")}
                        helperText={errors.last_name}
                        error={errors.last_name}
                        onBlur={(e) => handleBlurFn(e, "last_name")}
                      />
                    </Box>
                  </Col>
                </Row>
                <Box pb={22}>
                  <InputField
                    name="email"
                    type="text"
                    label="Email Id"
                    variant="standard"
                    required={true}
                    placeholder="Email"
                    fullWidth
                    labelBold
                    prefix={<TbMail />}
                    value={signUpData?.email}
                    onChange={(e) => handleChange(e.target.value, "email")}
                    helperText={errors.email}
                    error={errors.email}
                    onBlur={(e) => handleBlurFn(e, "email")}
                  />
                </Box>
                <Box pb={22}>
                  <InputField
                    name="phone"
                    type="tel"
                    label="Phone No"
                    variant="standard"
                    required={true}
                    placeholder="Phone No"
                    fullWidth
                    labelBold
                    prefix={<TbPhoneCall />}
                    value={signUpData?.phone}
                    onChange={(e) => handleChange(e.target.value, "phone")}
                    helperText={errors.phone}
                    error={errors.phone}
                    onBlur={(e) => handleBlurFn(e, "phone")}
                  />
                </Box>

                <Box pb={22}>
                  <SelectField
                    name="user_type"
                    fullWidth
                    variant="standard"
                    label="User Type"
                    labelBold
                    required={true}
                    options={[
                      { id: "single", name: "Individual" },
                      { id: "agent", name: "Agent" },
                    ]}
                    placeholder="Select Here..."
                    defaultValue={signUpData?.user_type}
                    onChange={(value) => handleChange(value, "user_type")}
                    helperText={errors.user_type}
                    error={errors.user_type}
                    onBlur={(e) => handleBlurFn(e, "user_type")}
                  />
                </Box>

                <Box pb={22}>
                  <InputField
                    type={showPassword ? "text" : "password"}
                    label="Password"
                    variant="standard"
                    required={true}
                    placeholder="Enter Password"
                    fullWidth
                    labelBold
                    prefix={
                      <PasswordToggleIcon onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
                        {showPassword ? <TbEyeOff /> : <TbEye />}
                      </PasswordToggleIcon>
                    }
                    value={signUpData?.password}
                    onChange={(e) => handleChange(e.target.value, "password")}
                    error={errors.password}
                    onBlur={(e) => handleBlurFn(e, "password")}
                    helperText={
                      <>
                        The password must adhere to the following pattern
                        <Tooltip
                          title={
                            <>
                              <ul>
                                <li>At least 8 characters in length.</li>
                                <li>Contains one uppercase letter (A-Z).</li>
                                <li>Contains one lowercase letter (a-z).</li>
                                <li>Contains one number (0-9).</li>
                                <li>
                                  Contains one special character (e.g., @, #, $,
                                  %, etc.).
                                </li>
                              </ul>
                            </>
                          }
                          position="top"
                          size="md"
                          color={errors.password ? "danger" : "primary"}
                        >
                          <TbInfoCircle />
                        </Tooltip>{" "}
                      </>
                    }
                  // helperText={errors.password}
                  />
                </Box>

                {errors.general && (
                  <Box pb={22}>
                    <Typography color="danger">{errors.general}</Typography>
                  </Box>
                )}

                <Row>
                  <Col md={7}>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      block
                      fullWidth
                      onClick={handleSubmit}
                    >
                      Sign Up
                    </Button>
                  </Col>
                </Row>

                <Gap height={"20"} />

                <Typography align="left" variant="body2" mt={"2"}>
                  Already have an account?
                  <Link to="/" variant="body2">
                    {" "}
                    Login
                  </Link>
                </Typography>
              </Col>
            </Row>
          </FromBox>

          <FooterBox>
            {/* <Typography variant="body2" color="dark" colorVariant="light">
              For more detailed information please review our{" "}
              <Link color="dark" underline="always" to="/">
                Privacy Policy.
              </Link>{" "}
              Need help?{" "}
              <Link color="dark" underline="always" to="/">
                Contact us
              </Link>
            </Typography> */}
          </FooterBox>
        </ContentBox>

      </ScreenLayout>

    </>
  );
};

export default Registration;
